module.exports = __webpack_public_path__ + "static/media/023.295934dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/023.jpg
// module id = 320
// module chunks = 0